import './Eingangsrechnungen';
import './Sachkostenabrechnungen';
import { dbh_helper } from '../src/dbh_helper';
import { dbh_ajax } from '../src/dbh_ajax';
import { dbh_loading } from '../src/dbh_loading';
import { dbh_filePreview } from '../Controls/dbh_filePreview';
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';

$(document).ready(function () {
    if (dbh_helper.getUrlArea() == "workflows" || dbh_helper.getUrlArea() == "") {
        $("#dbh_workflow").ready(function () {
            if ($("#dbh_workflow") && $("#dbh_workflow").length > 0) {

                dbh_helper.OnSetDefaultFormValues = () => {
                    BindDocumentFunctions();
                };

                $(".addDokument").on("click", function (e) {
                    new dbh_ajax().sendGetRequest({
                        actionName: "AddDokumentPopupView",
                        controllerName: "Workflows",
                        parameter: [["workflow", $(e.currentTarget).attr('data-workflow')]],
                        callbackSuccess: (ajaxResult: any) => {
                            $('#addDokument-placeholder').html(ajaxResult.responseText);
                            $('#AddDokumentViewComponentPopup').fadeIn("fast");
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                });

                BindDocumentFunctions();

                let timeoutAufgabeFilter = null;

                $("#aufagenFilterInput").on("keyup", function () {
                    const $this = $(this);

                    if (timeoutAufgabeFilter !== null) {
                        clearTimeout(timeoutAufgabeFilter);
                    }
                    timeoutAufgabeFilter = setTimeout(function () {
                        const curVal = $this.val().toString().toLowerCase();
                        const listItems = $("#listeAllerAufgaben .listItem");

                        if (curVal.length === 0) {
                            listItems.css("display", "flex");
                        } else {
                            for (let i = 0; i < listItems.length; i++) {
                                const texts = $(listItems[i]).find(".listItem-primaryText ,.listItem-secondaryText");
                                let textFound = false;

                                for (let j = 0; j < texts.length; j++) {
                                    if (texts[j].innerHTML.toLowerCase().indexOf(curVal) >= 0) {
                                        textFound = true;
                                    }
                                }

                                if (textFound) {
                                    $(listItems[i]).css("display", "flex");
                                } else {
                                    $(listItems[i]).css("display", "none");
                                }
                            }
                        }
                    }, 300);
                });

                $('.dbhErinnerung').on('click', (e) => {
                    dbh_helper.SendGetRequest("ErinnerungPopupView", "Home", [['id', $(e.currentTarget).attr('data-rowid')]], '#reminder-placeholder', function () {
                        $("#PopupErinnerungViewComponent").show();
                    });

                    e.stopPropagation();
                });

                $(document).on("click", "#reminderSavetBtn", function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    let dbhCustomValidation = new dbh_custom_validation();
                    if (!dbhCustomValidation.validateForm(form)) {
                        return;
                    }

                    let rawZeitpunkt = $(form).find("#Zeitpunkt").val().toString();
                    const arrZeitpunkt = rawZeitpunkt.split('.');
                    const zeitpunkt = `${arrZeitpunkt[1]}-${arrZeitpunkt[0]}-${arrZeitpunkt[2]}`;

                    new dbh_ajax().sendPostRequest({
                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                        actionName: "AddOrEditErinnerung",
                        controllerName: "Home",
                        parameter: [["id", $(e.currentTarget).attr('data-aufgabe')], ["zeitpunkt", zeitpunkt]],
                        callbackSuccess: (ajaxResult: any) => {

                            $('#listeAllerAufgaben .dbhErinnerung[data-rowid="' + $(e.currentTarget).attr('data-aufgabe') + '"]').first().addClass('active');
                            $("#PopupErinnerungViewComponent").hide();
                        }
                    });
                });

                $(document).on("click", "#reminderDeleteBtn", function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    new dbh_ajax().sendPostRequest({
                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                        actionName: "DeleteErinnerung",
                        controllerName: "Home",
                        parameter: dbh_helper.getParameterArrayForForm(form),
                        callbackSuccess: (ajaxResult: any) => {
                            $('#listeAllerAufgaben .dbhErinnerung[data-rowid="' + $(e.currentTarget).attr('data-aufgabe') + '"]').first().removeClass('active');
                            $("#PopupErinnerungViewComponent").hide();
                        }
                    });

                });

                $(document).on("click", "#reminderCancelBtn", function () {
                    $("#PopupErinnerungViewComponent").hide();
                });

                // Wenn URL Parameter enthält, dann wird dieser im ViewBag übergeben und zum Start der entsprechende Workflow geladen
                if ($("#hdnWorkflowIdFirstLoad").val() != "") {
                    try {
                        $('.dbhAufgabe[data-rowid="' + $("#hdnWorkflowIdFirstLoad").val() + '"]').get(0).click();
                        // Feld leeren, damit nicht erneut dieser Workflow geladen wird
                        $("#hdnWorkflowIdFirstLoad").val("");
                    } catch (e) {

                    }
                }

                $(document).on("click", ".aufgabe-details-viewswitch span", function () {
                    const $this = $(this);
                    if (!$this.hasClass("active")) {
                        $this.closest(".aufgabe-details-viewswitch").find("span").removeClass("active");
                        $this.addClass("active");
                        $(".view").removeClass("active");
                        $(`#${$this.data("id")}`).addClass("active");
                    }
                });
            }
        });

        const BindDocumentFunctions = () => {
            $('.dbhAufgabe').off("click");
            $('.dbhAufgabe').on('click', function (e) {
                $('.dbhAufgabe').removeClass("active");
                $(this).addClass("active");

                new dbh_ajax().sendGetRequest({
                    actionName: "Get" + $(e.currentTarget).attr('data-workflow') + "ViewComponent",
                    controllerName: "Workflows",
                    parameter: [["id", $(e.currentTarget).attr('data-rowid')]],
                    callbackSuccess: (ajaxResult: any) => {
                        $('#placeholderAktiveAufgabe').html(ajaxResult.responseText);
                        $('#aktiveWorkflowAufgabe').removeClass();
                        $('#aktiveWorkflowAufgabe').addClass("active");
                        $('#aktiveWorkflowAufgabe').addClass($(e.currentTarget).attr('data-workflow'));

                        $("#placeholderAktiveAufgabe").ready(function () {

                            var loading: dbh_loading = new dbh_loading();
                            loading.onLoading('previewContainer');

                            sendGetRequestForFilePreview(
                                [['id', $(e.currentTarget).attr('data-rowid')]],
                                loading);

                            $('#btnPrimaryDokumentEntfernen').on('click', (e) => {
                                if (confirm("Soll das Dokument wirklich gelöscht weden?")) {
                                    var form = dbh_helper.findNearestForm(e.currentTarget);

                                    new dbh_ajax().sendPostRequest({
                                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                        actionName: "DeleteDokument",
                                        controllerName: "Workflows",
                                        parameter: [["idAufgaben", $('#PK_Aufgaben').val()]],
                                        callbackSuccess: (ajaxResult: any) => {

                                            let pk_Aufgaben = $('input[name="PK_Aufgaben"]').val();
                                            // Eintrag aus Tabelle entfernen                
                                            $('#listeAllerAufgaben [data-rowid="' + pk_Aufgaben + '"]').first().remove();
                                            $('#placeholderAktiveAufgabe').html("");
                                            $(`#previewContainer`).html("");

                                            if ($('#listeAllerAufgaben').children().length == 0) {
                                                window.location.reload();
                                            }

                                        },
                                        callbackError: (ajaxResult: any) => {

                                            $('#dbhErrorDokumentEntfernen').html(ajaxResult.responseJSON.message).show();
                                        }
                                    });
                                }
                                e.stopPropagation();
                            });

                            $('#btnAblehnen').on('click', (e) => {
                                const hdnReqOnReject = $('#RequiredOnReject');
                                if (hdnReqOnReject.length > 0) {
                                    hdnReqOnReject.val('True');
                                }

                                const form = dbh_helper.findNearestForm(e.currentTarget);
                                const workflowType = $("#workflowType").val();

                                let dbhCustomValidation = new dbh_custom_validation();
                                if (!dbhCustomValidation.validateForm(form)) {
                                    return;
                                }

                                new dbh_ajax().sendPostRequest({
                                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                    actionName: `Ablehnen${workflowType}`,
                                    controllerName: "Workflows",
                                    parameter: dbh_helper.getParameterStringForForm(form),
                                    callbackSuccess: (ajaxResult: any) => {
                                        let pk_Aufgaben = $('input[name="PK_Aufgaben"]').val();
                                        // Eintrag aus Tabelle entfernen                
                                        $('#listeAllerAufgaben [data-rowid="' + pk_Aufgaben + '"]').first().remove();
                                        $('#placeholderAktiveAufgabe').html('<div class="gespeichert"><span class="tasksDoneIcon">&#10003;</span><span>Ablehnung gespeichert!</span></div>');

                                        $(`#previewContainer`).html("");

                                        if ($('#listeAllerAufgaben').children().length == 0) {
                                            window.location.reload();
                                        }
                                    },
                                    callbackError: (ajaxResult: any) => {
                                    }
                                });
                                e.stopPropagation();
                            });
                            $('#btnFreigeben').on('click', (e) => {
                                const hdnReqOnReject = $('#RequiredOnReject');
                                if (hdnReqOnReject.length > 0) {
                                    hdnReqOnReject.val('False');
                                }

                                const form = dbh_helper.findNearestForm(e.currentTarget);

                                let dbhCustomValidation = new dbh_custom_validation();
                                if (!dbhCustomValidation.validateForm(form)) {
                                    return;
                                }

                                const workflowType = $("#workflowType").val();

                                new dbh_ajax().sendPostRequest({
                                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                    actionName: `Freigeben${workflowType}`,
                                    controllerName: "Workflows",
                                    parameter: dbh_helper.getParameterStringForForm(form),
                                    callbackSuccess: (ajaxResult: any) => {
                                        let pk_Aufgaben = $('input[name="PK_Aufgaben"]').val();
                                        // Eintrag aus Tabelle entfernen                
                                        $('#listeAllerAufgaben [data-rowid="' + pk_Aufgaben + '"]').first().remove();
                                        $('#placeholderAktiveAufgabe').html('<div class="gespeichert"><span class="tasksDoneIcon">&#10003;</span><span>Freigabe gespeichert!</span></div>');
                                        $(`#previewContainer`).html("");

                                        if ($('#listeAllerAufgaben').children().length == 0) {
                                            window.location.reload();
                                        }
                                    },
                                    callbackError: (ajaxResult: any) => {
                                    }
                                });
                                e.stopPropagation();
                            });
                        });
                    },
                    callbackError: (ajaxResult: object) => {
                    }
                });

                e.stopPropagation();
            });

            $('.aufgaben-header-1').off("click");
            $('.aufgaben-header-1').on("click", function () {
                let curOrder = $(this).data("orderby");

                if (curOrder === "desc") {
                    curOrder = "asc";
                    $(this).removeClass("desc");
                    $(this).addClass("asc");
                } else {
                    curOrder = "desc";
                    $(this).removeClass("asc");
                    $(this).addClass("desc");
                }

                let $dbhAufgabe = $('.dbhAufgabe');
                if ($dbhAufgabe.length > 0) {
                    if (curOrder === "asc") {
                        //@ts-ignore
                        $dbhAufgabe = $dbhAufgabe.sort(
                            (a, b) => { return $(a).data("order1") - $(b).data("order1") }
                        );
                    } else {
                        //@ts-ignore
                        $dbhAufgabe = $dbhAufgabe.sort(
                            (a, b) => { return $(b).data("order1") - $(a).data("order1") }
                        );
                    }

                    for (let i = 0; i < $dbhAufgabe.length; i++) {
                        $($dbhAufgabe[i]).css("order", `${i}`);
                    }

                    $(this).data("orderby", curOrder);
                }
            });

            $('#FK_Belegungen').off("change");
            $('#FK_Belegungen').change(function () {
                new dbh_ajax().sendGetRequest({
                    actionName: "GetStandortFuerBelegung",
                    controllerName: "Home",
                    parameter: [["fk_Belegungen", $(this).val() as any]],
                    callbackSuccess: (ajaxResult: any) => {
                        if (ajaxResult.responseText.toLowerCase().replaceAll("\"", "") == "eaa6bac3-2378-41d8-9078-0b8485d31ecb") {
                            if (!$('.dbhKoordinatorInnenAndere').hasClass("hidden")) {
                                $('.dbhKoordinatorInnenAndere').addClass("hidden");
                            }
                            if ($('.dbhKoordinatorInnenKöln').hasClass("hidden")) {
                                $('.dbhKoordinatorInnenKöln').removeClass("hidden");
                            }
                        }
                        else {
                            if (!$('.dbhKoordinatorInnenKöln').hasClass("hidden")) {
                                $('.dbhKoordinatorInnenKöln').addClass("hidden");
                            }
                            if ($('.dbhKoordinatorInnenAndere').hasClass("hidden")) {
                                $('.dbhKoordinatorInnenAndere').removeClass("hidden");
                            }
                        }
                    }
                });
            });
        }
    }
});

const sendGetRequestForFilePreview = (parameter, loading) => {
    new dbh_ajax().sendGetRequest(
        {
            actionName: "GetPdfOrImgPreview",
            controllerName: "Home",
            parameter: parameter,
            callbackSuccess: (ajaxResult: any) => {
                $(`#previewContainer`).html(ajaxResult.responseText);
                $(`#previewContainer`).addClass("active");
                loading.onLoadingFinished();
            }
        });
}